import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { MobileNav } from "@/components/MobileNav";
import { Footer } from "@/components/Footer";
import { WhatsAppWidget } from "@/components/WhatsAppWidget";
import { HomePage } from "@/pages/HomePage";
import { ShopPage } from "@/pages/ShopPage";
import { ProductPage } from "@/pages/ProductPage";
import { BlogPage } from "@/pages/BlogPage";
import { BlogPostPage } from "@/pages/BlogPostPage";
import { ContactPage } from "@/pages/ContactPage";
import { AboutPage } from "@/pages/AboutPage";
import { CheckoutPage } from "@/pages/CheckoutPage";
import { OrderConfirmationPage } from "@/pages/OrderConfirmationPage";
import { AdminLoginPage } from "@/pages/admin/AdminLoginPage";
import { AdminDashboardPage } from "@/pages/admin/AdminDashboardPage";
import { AdminProductsPage } from "@/pages/admin/AdminProductsPage";
import { AdminOrdersPage } from "@/pages/admin/AdminOrdersPage";
import { AdminBlogPage } from "@/pages/admin/AdminBlogPage";
import { AdminMessagesPage } from "@/pages/admin/AdminMessagesPage";
import { AdminImagesPage } from "@/pages/admin/AdminImagesPage";

// Layout for public pages
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main className="pb-mobile-nav">{children}</main>
    <Footer />
    <MobileNav />
    <WhatsAppWidget />
  </>
);

function App() {
  return (
    <div className="App min-h-screen bg-bone-cream">
      <div className="grain-overlay" />
      <CartProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/shop" element={<PublicLayout><ShopPage /></PublicLayout>} />
            <Route path="/shop/:category" element={<PublicLayout><ShopPage /></PublicLayout>} />
            <Route path="/product/:productId" element={<PublicLayout><ProductPage /></PublicLayout>} />
            <Route path="/blog" element={<PublicLayout><BlogPage /></PublicLayout>} />
            <Route path="/blog/:slug" element={<PublicLayout><BlogPostPage /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/checkout" element={<PublicLayout><CheckoutPage /></PublicLayout>} />
            <Route path="/order-confirmation/:orderId" element={<PublicLayout><OrderConfirmationPage /></PublicLayout>} />

            {/* Admin Routes (no public layout) */}
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/products" element={<AdminProductsPage />} />
            <Route path="/admin/products/new" element={<AdminProductsPage />} />
            <Route path="/admin/orders" element={<AdminOrdersPage />} />
            <Route path="/admin/blog" element={<AdminBlogPage />} />
            <Route path="/admin/blog/new" element={<AdminBlogPage />} />
            <Route path="/admin/messages" element={<AdminMessagesPage />} />
            <Route path="/admin/images" element={<AdminImagesPage />} />
            <Route path="/admin/subscribers" element={<AdminMessagesPage />} />
          </Routes>
          <Toaster position="top-center" />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
